import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'highlight',
   standalone: true, 
})
export class HighlightPipe implements PipeTransform {

  transform(value: string, search: string): string {
      if (!search) return value;

      // Create regex to match all case-insensitive occurrences of search
      const regex = new RegExp(`(${search})`, 'gi');

      // Replace all matches with highlighted version
      return value.replace(regex, `<b>$1</b>`);
      
  }
  
}
